import { USER_ROLE } from '~/shared/constants';
import type { LessonPolicyContext } from '~/shared/permissions/types';

export function canLesson(user, permission, ctx: LessonPolicyContext = { lesson: null }) {
  const lesson = ctx.lesson;

  switch (permission) {
    case 'lesson.view':
      return [
        USER_ROLE.ADMIN,
        USER_ROLE.MANAGER,
        USER_ROLE.SUPER_TEACHER,
        USER_ROLE.TEACHER,
        USER_ROLE.STUDENT,
      ].includes(user.role);

    case 'lesson.start':
      return (
        [USER_ROLE.ADMIN, USER_ROLE.SUPER_TEACHER].includes(user.role) ||
        (user.role === USER_ROLE.TEACHER && lesson?.creator === user._id)
      );

    case 'lesson.edit':
      return (
        user.role === USER_ROLE.ADMIN ||
        user.role === USER_ROLE.SUPER_TEACHER ||
        (user.role === USER_ROLE.TEACHER && lesson?.creator === user._id)
      );

    case 'lesson.finish':
      return (
        user.role === USER_ROLE.ADMIN ||
        user.role === USER_ROLE.SUPER_TEACHER ||
        (user.role === USER_ROLE.TEACHER && lesson?.creator === user._id)
      );

    default:
      return false;
  }
}
